import { render, staticRenderFns } from "./_slug.vue?vue&type=template&id=754a40fa"
import script from "./_slug.vue?vue&type=script&lang=js"
export * from "./_slug.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PagesCategoryPage: require('/app/components/pages/CategoryPage.vue').default,PagesProductPage: require('/app/components/pages/ProductPage.vue').default})
